<template>
    <div id="caseDetail" class="sys-page">
        <div class="page-head">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{path:'/caseManage'}" replace>病例管理</el-breadcrumb-item>
                <el-breadcrumb-item>病例详情</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-form ref="form" :model="form" label-width="100px">
            <div class="box">
                <p class="title">患者信息</p>
                <p class="statue">{{transformStatus(form)}}</p>
                <el-card class="box-card">
                    <div class="itemBox">
                        <el-form-item label="姓名：">
                            <p>{{form.patientName}}</p>
                        </el-form-item>
                        <el-form-item label="性别：">
                            <p>{{form.patientGender=="F"?'女':'男'}}</p>
                        </el-form-item>
                        <el-form-item label="电话：">
                            <p>{{form.patientTel}}</p>
                        </el-form-item>
                    </div>
                    <div class="itemBox">
                        <el-form-item label="年龄：">
                            <p>{{form.patientAge+'岁'}}</p>
                        </el-form-item>
                        <el-form-item label="身份证号：">
                            <p>{{form.patientIdCard}}</p>
                        </el-form-item>
                        <el-form-item label="报销类型：">
                            <p>{{transformExpense(form)}}</p>
                        </el-form-item>
                    </div>
                    <div class="itemBox">
                        <el-form-item label="是否急诊：">
                            <p>{{emergForamt(form)}}</p>
                        </el-form-item>
                        <el-form-item label="转诊目的：">
                            <p>{{transformPurpose(form)}}</p>
                        </el-form-item>
                        <el-form-item label="转诊时间：">
                            <p>{{form.transferTime}}</p>
                        </el-form-item>
                    </div>
                    <div class="itemBox">
                        <el-form-item label="申请医院：">
                            <p>{{form.applyHospName}}</p>
                        </el-form-item>
                        <el-form-item label="申请医生：">
                            <p>{{form.applyDocName}}</p>
                        </el-form-item>
                        <el-form-item label="申请时间：">
                            <p>{{form.applyTime}}</p>
                        </el-form-item>
                    </div>
                    <el-form-item label="主诉：" style="width:100% !important;">
                        <p>{{form.medicalComplaint}}</p>
                    </el-form-item>
                    <el-form-item label="病史：" style="width:100% !important;">
                        <p>{{form.medicalHistory}}</p>
                    </el-form-item>
                    <el-form-item label="初诊：" style="width:100% !important;">
                        <p>{{form.initDiagOpinion}}</p>
                    </el-form-item>
                    <el-form-item label="备注：" style="width:100% !important;">
                        <p>{{form.comment}}</p>
                    </el-form-item>
                </el-card>
                <p class="title" v-if="form.caseStatus=='03'||form.caseStatus=='04'||form.caseStatus=='05'">转诊结果</p>
                <el-card class="box-card" v-if="form.caseStatus=='03'||form.caseStatus=='04'">
                    <el-form-item label="确认医生：">
                        <p>{{form.confirmDocName}}</p>
                    </el-form-item>
                    <el-form-item label="接诊医生：" v-if="form.caseStatus=='04'">
                        <p>{{form.receiveDocName}}</p>
                    </el-form-item>
                    <el-form-item label="接诊建议：" style="width:100%!important">
                        <p>{{form.receiveSuggest}}</p>
                    </el-form-item>
                </el-card>
                <el-card class="box-card" v-if="form.caseStatus=='05'">
                    <el-form-item label="拒绝医生：">
                        <p>{{form.confirmDocName}}</p>
                    </el-form-item>
                    <el-form-item label="拒绝原因：" style="width:100%!important">
                        <p>{{form.receiveSuggest}}</p>
                    </el-form-item>
                </el-card>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="back()">返回</el-button>
                    <!-- <el-button v-if="form.caseStatus=='04'" type="primary" @click="seeReport(form)">查看转诊单</el-button> -->
                </span>
            </div>
        </el-form>
        
    </div>
    
</template>

<script>
export default {
    name:'caseDetail',
    data(){
        return{
            userInfo:'',
            report:false,
            caseId:'',
            url:'https://new-zhuanzhen.oss-cn-beijing.aliyuncs.com/', 
            form:{},
            examAttach:[],
            reportMsg:{
                caseId:'',
                diagOpinion:'',//诊断意见
                reportName:'',//报告名字
                reportUrl:''//报告路径
            },
            //急诊
            emergStatusList:[
                {"code":"1","value":"是"},
                {"code":"0","value":"否"},
            ],
            //转诊目的
            purposeList:[
                {"code":"01","value":"门诊"},
                {"code":"02","value":"住院"},
                {"code":"03","value":"检查"},
                {"code":"04","value":"随访"},
                {"code":"05","value":"康复"},
                {"code":"99","value":"其他"},
            ],
            //状态列表
            statusList:[
                {"code":"01","value":"待申请"},
                {"code":"02","value":"待确认"},
                {"code":"03","value":"待到诊"},
                {"code":"04","value":"已到诊"},
                {"code":"05","value":"已拒绝"}
            ],
            //报销类型
            expenseList:[
                {"code":"01","value":"城镇医保"},
                {"code":"02","value":"职工医保"},
                {"code":"03","value":"新农合"},
                {"code":"04","value":"自费"},
                {"code":"99","value":"其他"}
            ],
        }
    },
    mounted(){
        this.caseMsg=this.$common.getStorage('caseMsg');
        this.reportMsg.caseId=this.caseMsg.caseId;
        this.init(this.caseMsg.caseId);
    },
    methods:{
        deleteMsg(data){
            this.examAttach=[];
        },
        //获取病历信息
        init(caseId){
            this.$ajax.post(this.$domain.caseDetail,{
                caseId:caseId
            })
            .then(ret=>{
                this.$common.getConsole('caseDetail.vue--获取病历信息',ret.data)
                if(ret.data.code==200){
                    this.form=ret.data.data;
                }
                else if(ret.data.code=='502'){
                    this.$message.error('登录失效，请重新登录!')
                    this.$router.push({path:'/login'});
                }
                else if(ret.data.code!='201'){
                    this.$message.error(ret.data.message);
                }
            })
        },
        //查看报告
        seeReport(form){
            window.open(this.url+form.transferBill.attachUrl);
        },
        //打开文件
        openFile(url){
            window.open(this.url+url);
        },
        //是否急诊文字转化
        emergForamt(row){
            switch(row.emergStatus){
                case 0:return '否';break;
                case 1:return '是';break;
            }
        },
        //状态文字转换
        transformStatus(row){
            for(var i=0;i<this.statusList.length;i++){
                if(row.caseStatus==this.statusList[i].code){
                    return this.statusList[i].value 
                }
            }
        },
        //转诊目的转换
        transformPurpose(row){
            for(var i=0;i<this.purposeList.length;i++){
                if(row.transferPurpose==this.purposeList[i].code){
                    return this.purposeList[i].value
                }
            }
        },
        //报销类型
        transformExpense(row){
            for(var i=0;i<this.expenseList.length;i++){
                if(row.expenseType==this.expenseList[i].code){
                    return this.expenseList[i].value
                }
            }
        },
        back(){
            this.$router.push({path:'caseManage'})
        }
    }
}
</script>

<style lang="scss" scoped>
#caseDetail{
    width:100%;
    padding:20px 40px;
    box-sizing: border-box;
    text-align: center;
    .box{
        width:90%;
        max-width:1400px;
        margin: auto;
        margin-bottom:20px;
        font-size: 18px;
        position: relative;
        .statue{
            position: absolute;
            top:0px;
            right:20px;
            color:rgb(38, 159, 175);
            font-size: 30px;
        }
        .title{
            font-size: 24px;
            margin-top:30px;
            text-align: left;
            color:#0659C5;
            font-weight: bold;
            padding:10px 10px;
            border-bottom:1px solid #0659C5;
        }
        .box-card{
            margin-top:20px;
            .itemBox{
                display: flex;
                justify-content: space-around;
            }
            .el-form-item{
                width:33%!important;
                text-align: left;
            }
            .el-form-item__content{
                margin:0!important;
            }
            .fileList{
                list-style:none;
                margin-right:20px;
                cursor: pointer;
                color:#07b107
            }
            .fileList:hover{
                color:#017a01;
            }
        }
        .dialog-footer{
            display: flex;
            margin-top:20px;
        }
    }
}

</style>



// WEBPACK FOOTER //
// src/page/caseDetail.vue